<template>
    <div class="card h-auto col-md-6 col-md-6 col-sm-12 mt-md-0 mb-lg-0 mb-md-0 mb-4 position-relative">
        <div v-if="loading" class="d-flex justify-content-center align-items-center col-12"
            style="height: 100px;top: 0;left: 0;">
            <p class="text-center"><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
        </div>

        <div v-else>
            <div v-if="!openParcels || openParcels.length === 0" class="row">
                <div class="col-12 segment-primary-color d-flex justify-content-center font-weight-bolder mt-6">
                    Nenhuma Parcela Encontrada Para Este Mês
                </div>
            </div>

            <div v-else>
                <div class="row mt-3 mx-4">
                    <div class="col-6 col-sm-6 col-md-6">
                        <div class="row d-flex font-weight-bolder justify-content-start line">Próxima Parcela</div>
                        <div class="row d-flex justify-content-start line bg-custom">Origem</div>
                        <div class="row d-flex justify-content-start line">Tipo</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6">
                        <div class="row d-flex font-weight-bolder justify-content-end line">
                            {{ formatDate(currentParcel.par_dt_vencimento) }}
                        </div>
                        <div class="row d-flex justify-content-end bg-custom line">{{ currentParcel.par_origem_parcela
                            }}
                        </div>
                        <div class="row d-flex justify-content-end line">{{ currentParcel.par_ch_parcela }}</div>
                    </div>
                </div>
                <div class="row mx-3">
                    <div class="row d-flex justify-content-center font-weight-bolder segment-primary-color"
                        style="font-size: 1.3rem;padding: 8px 0;">
                        {{ currencyFormat(currentParcel.par_re_valororiginal) }}
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="font-weight-bolder mt-1 d-flex flex-wrap justify-content-center">
                        <div class="col-6 mb-2 d-flex justify-content-center">
                            <button @click="copyCode" :disabled="!currentParcel.barcode"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100"
                                style="white-space: nowrap;">Copiar código
                            </button>
                        </div>
                        <!-- PIX só aparece quando o boleto veio da CUB e traz o copia-e-cola -->
                        <div v-if="temPix(currentParcel)" class="col-6 mb-2 d-flex justify-content-center">
                            <button type="button" @click="copyPix"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100"
                                style="white-space: nowrap;">Copiar PIX
                            </button>
                        </div>
                        <div class="col-6 mb-2 d-flex justify-content-center">
                            <button type="button" @click="showPaymentSlip"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100" :disabled="loadingVisiblePaymetSlip"
                                style="white-space: nowrap;">Ver boleto <i v-if="loadingVisiblePaymetSlip" class="fa fa-spinner fa-pulse fa-fw"></i>
                            </button>
                        </div>
                        <div class="col-6 mb-2 d-flex justify-content-center">
                            <button type="button" @click="visible = true"
                                class="btn custom-btn custom-btn-sm bg-segment-primary-color w-100"
                                style="white-space: nowrap;">Receber por e-mail
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="openParcels.length > 1">
            <div class="btn-container left">
                <a @click="previousParcel" :disabled="currentIndex === 0" class="btn-icon">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>
            <div class="btn-container right">
                <a @click="nextParcel" :disabled="currentIndex === openParcels.length - 1" class="btn-icon">
                    <i class="fas fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>

    <Dialog v-model:visible="visible" modal header="Receber por e-mail" :style="{ width: '25rem' }">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <argon-input id="mail" v-model="email" class="multisteps-form__input" type="text"
                placeholder="mail@mail.com.br" />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button type="button" @click="sendMail()" :disabled="loadingRequestMail"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">Confirmar <i
                    v-if="loadingRequestMail" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>

    <Dialog v-model:visible="visiblePaymetSlip" modal header="" :style="{ width: '25rem' }">
        <div ref="pdfContainer" style="width: 100%; height: 600px;"></div>
    </Dialog>
</template>

<script setup>
import axios from 'axios';
import { onMounted, ref, computed } from 'vue';
import moment from 'moment';
import { useStore } from "vuex";
import { showToast } from "@/assets/js/toast.js";
import Dialog from 'primevue/dialog';
import ArgonInput from "@/components/ArgonInput.vue";
import {
    abrirBoleto,
    copiarLinhaDigitavel,
    copiarPix,
    temPix,
} from "@/helpers/boleto";

const store = useStore();

const contractData = computed(() => store.getters.getCurrentContract);
const openParcels = ref([]);
const currentIndex = ref(0);
const loading = ref(true);
const loadingRequestMail = ref(false);
const visible = ref(false);
const visiblePaymetSlip = ref(false);
const loadingVisiblePaymetSlip = ref(false);
const email = ref('');

const currentParcel = computed(() => openParcels.value[currentIndex.value]);
const userAgent = store.getters.getCurrentUser ? store.getters.getCurrentUser.id : null;

onMounted(async () => {
    moment.locale('pt-br');
    openParcels.value = await fetchOpenParcels();
    loading.value = false;
});

async function fetchOpenParcels() {
    try {
        const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ABERTO`);
        console.log(response);

        return response.data.length ? response.data : [];
    } catch (error) {
        console.log(error);
        return [];
    }
}

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

// Linha digitável: do MEGA ou, havendo boleto na CUB, da CUB. O backend já
// resolveu a origem — aqui é só copiar o que veio na parcela.
const copyCode = async () => {
    if (await copiarLinhaDigitavel(currentParcel.value)) {
        showToast('Código copiado para a área de transferência', 'success');
    } else {
        showToast('Não foi possível copiar o código.', 'error');
    }
};

const copyPix = async () => {
    if (await copiarPix(currentParcel.value)) {
        showToast('PIX copiado para a área de transferência', 'success');
    } else {
        showToast('Não foi possível copiar o PIX.', 'error');
    }
};


async function sendMail() {
    try {
        loadingRequestMail.value = true

        // `/boleto-email` reenvia o boleto que já existe. A rota anterior era
        // `/duplicate`, que **emite uma segunda via** — pedir duas vezes
        // gerava dois boletos. Ver EMAIL-BOLETO-LEVANTAMENTO.md.
        let data = {
            parcel: currentParcel.value.par_in_codigo,
            email: email.value,
        };

        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/boleto-email`, data);

        if (response.data?.result?.ERRO) {
            showToast(response.data.result.DESCRICAO, 'error');
        } else {
            showToast('Boleto enviado para ' + email.value, 'success');
        }
    } catch (error) {
        const detalhe = error?.response?.data?.result?.DESCRICAO
            || 'Não foi possível enviar o boleto.';
        showToast(detalhe, 'error');
        console.log(error);
    } finally {
        visible.value = false
        loadingRequestMail.value = false
    }
}

// Com boleto na CUB a parcela já traz `pdf_url` e a aba abre sem request.
// Sem ela, o helper cai no `/boleto-ws` de sempre.
async function showPaymentSlip() {
    try {
        loadingVisiblePaymetSlip.value = true

        const resultado = await abrirBoleto(currentParcel.value, {
            contrato: contractData.value.contrato_id,
            agente: userAgent,
        });

        if (!resultado.ok) {
            showToast(resultado.erro, 'error');
        }
    } finally {
        loadingVisiblePaymetSlip.value = false
    }
}

const nextParcel = () => {
    if (currentIndex.value < openParcels.value.length - 1) {
        currentIndex.value++;
    }
};

const previousParcel = () => {
    if (currentIndex.value > 0) {
        currentIndex.value--;
    }
};
</script>

<style scoped>
.btn {
    margin-bottom: 1rem !important;
    letter-spacing: -.025rem !important;
    font-size: .75rem !important;
    padding: 7px 20px !important;
    text-transform: none !important;
    box-shadow: 0 4px 6px rgba(50, 50, 93, .1), 0 1px 3px rgba(0, 0, 0, .08) !important;
}

.custom-btn-sm {
    /* Largura fixa cortava os rótulos mais longos ("Receber por e-mail"
       precisava de 132px numa coluna de 98px). Agora acompanha a coluna. */
    max-width: 170px;
    margin: 0px 4px 12px 4px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}

.btn-icon {
    background: none;
    border: none;
    padding: 0;
    font-size: 1.5rem;
    cursor: pointer;
}

.position-relative {
    position: relative;
}

.btn-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.btn-container.left {
    left: 10px;
}

.btn-container.right {
    right: 10px;
}

.bg-custom {
    background-color: #FAFAFA;
}

.line {
    padding-left: 5px;
    padding-right: 5px;
    white-space: nowrap;
}
</style>
